import { Button } from '@ps-design-system/components/Button';
import ArrowLeftIcon from '@ps-design-system/icons/ArrowLeft/ArrowLeft24';
import ArrowRightIcon from '@ps-design-system/icons/ArrowRight/ArrowRight24';
import React, { useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import Slider from 'react-slick';
import { useCarouselArrows } from 'shared-components/carousel/utils/use-carousel-arrows';
import { checkCateringEligibility } from '../../catering/catering-utils';
import { AddCateringCard } from './AddCateringCard';
import { InviteToBookCard } from './InviteToBookCard';
import { ReferralsCard } from './ReferralsCard';

export const InboxNextStepsSlider = ({
  inviteCreated,
  showReferralCard,
  router,
  pid,
  bookingDetails
}) => {
  const sliderRef = useRef();
  const { arrowDisabled, displayArrows, handleBeforeChange, onReInit } =
    useCarouselArrows(sliderRef);

  const slides = [];

  const isEligibleForCatering = checkCateringEligibility(
    bookingDetails?.metro,
    bookingDetails?.attendees,
    bookingDetails?.schedule?.[0]?.start
  );
  if (isEligibleForCatering) {
    slides.push(
      <AddCateringCard router={router} bookingId={bookingDetails?.booking_id} />
    );
  }

  if (bookingDetails?.is_instant_booking) {
    if (inviteCreated) {
      slides.push(showReferralCard && <ReferralsCard />);
    } else {
      slides.push(
        <InviteToBookCard
          bookingId={bookingDetails?.booking_id}
          router={router}
          pid={pid}
        />
      );
    }
  } else {
    slides.push(showReferralCard && <ReferralsCard />);
  }

  const filteredSlides = slides.filter(Boolean);

  if (!filteredSlides.length) {
    return null;
  }

  return (
    <div className="inbox-next-steps-container">
      {1 < filteredSlides.length && (
        <h2
          className="no-margin tw-headline-2-m flex middle space-between"
          style={{
            marginBottom: '16px'
          }}
        >
          <FormattedMessage
            id="next_steps_slider.next_steps"
            defaultMessage="Next steps"
          />
          {displayArrows && (
            <div className="flex middle" style={{ gap: '24px' }}>
              <Button
                onClick={() => sliderRef.current.slickPrev()}
                disabled={arrowDisabled.left}
                variant="text-only"
              >
                <ArrowLeftIcon/>
              </Button>
              <Button
                onClick={() => sliderRef.current.slickNext()}
                disabled={arrowDisabled.right}
                variant="text-only"
              >
                <ArrowRightIcon/>
              </Button>
            </div>
          )}
        </h2>
      )}
      <Slider
        ref={sliderRef}
        className="InboxNextStepsSlider"
        slidesToShow={1}
        slidesToScroll={1}
        speed={500}
        infinite={false}
        swipeToSlide={true}
        draggable={true}
        swipe={true}
        lazyLoad="progressive"
        onReInit={() => onReInit(filteredSlides.length)}
        beforeChange={(oldIndex, newIndex) => {
          handleBeforeChange(oldIndex, newIndex, filteredSlides.length);
        }}
        responsive={[
          {
            breakpoint: 3000,
            settings: {
              slidesToShow: 1
            }
          }
        ]}
      >
        {filteredSlides}
      </Slider>
    </div>
  );
};
